module.exports = __webpack_public_path__ + "static/media/LearnCreatorHowItWorks4.293ad481.png";